export default __webpack_public_path__ + "static/media/profile-photo.cbfbc534.png";